export default {
    namespaced: true,
    alarm_groups: {
      title: "Grupos de alarma | Grupo de alarma",
      name: 'Nombre',
      group: 'Agrupar',
      select: 'Seleccione uno o más grupos'
    }
};
